import {
  Box,
  Table,
  Text,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  BoxProps,
  Icon,
  ButtonGroup,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { RiAddLine, RiEyeLine } from 'react-icons/ri';
import { LinkButton } from '../../../../../../../../../../../components/LinkButton';
import { useAuth } from '../../../../../../../../../../../hooks/auth';
import { useUser } from '../../../../../../../../../../../hooks/user';
import { IUserBase } from '../../../../../../../../../../../models/users';
import { listUserGuestsService } from '../../../../../../../../../../../services/Users/ListUserGuestsService';

type IMemberGuestTableProps = BoxProps;

export const MemberGuestTable = (
  props: IMemberGuestTableProps,
): JSX.Element => {
  const { user: authenticatedUser } = useAuth();

  const { user: member } = useUser();

  const [guests, setGests] = useState<IUserBase[]>([]);

  useEffect(() => {
    async function loadMemberGuests(memberId: string): Promise<void> {
      const guestsList = await listUserGuestsService({
        groupKey: 'GUEST',
        hostId: memberId,
      });

      setGests(guestsList.items);
    }

    if (member?.id) {
      loadMemberGuests(member.id);
    }
  }, [member?.id, setGests]);

  return (
    <Box {...props}>
      {!!member && (
        <>
          <ButtonGroup justifyContent="flex-end" w="full">
            {authenticatedUser.featureGroup.features.some((feature) =>
              ['USER_FULL_ACCESS', 'USER_WRITE_ACCESS'].includes(feature.key),
            ) && (
              <LinkButton
                colorScheme="green"
                icon={<Icon as={RiAddLine} fontSize="16" />}
                to={{
                  pathname: '/guests/register',
                  state: {
                    groupKey: 'GUEST',
                    hostId: member.id,
                  },
                }}
              >
                Register new
              </LinkButton>
            )}
          </ButtonGroup>

          <Table colorScheme="blue">
            <Thead>
              <Tr>
                <Th>Name</Th>

                <Th>Phone</Th>

                <Th textAlign="center" w="8" />
              </Tr>
            </Thead>

            <Tbody>
              {guests.map((guest) => (
                <Tr key={guest.id}>
                  <Td>
                    <Text fontWeight="bold">{guest.name}</Text>
                  </Td>

                  <Td>{guest.phone}</Td>

                  <Td textAlign="center">
                    <LinkButton
                      px={0}
                      to={{
                        pathname: '/guests/details',
                        state: {
                          guestId: guest.id,
                        },
                      }}
                    >
                      <Icon as={RiEyeLine} fontSize="16" />
                    </LinkButton>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </>
      )}
    </Box>
  );
};
